/**
 * The heading of a column of figures or controls: small, uppercase and quiet,
 * so it reads as structure and leaves the weight to the rows.
 */
export const COLUMN_HEADING = {
  typography: "caption",
  fontWeight: 600,
  color: "text.secondary",
  letterSpacing: ".04em",
  textTransform: "uppercase",
  whiteSpace: "nowrap",
} as const;

/**
 * A slider with a slim track and a hollow thumb, for rows of figures where the
 * default thumb would outweigh the numbers it sets.
 */
export const QUIET_SLIDER = {
  height: 5,
  "& .MuiSlider-thumb": {
    width: 16,
    height: 16,
    bgcolor: "background.paper",
    border: "2px solid currentColor",
  },
} as const;
